<template>
  <div>
    <agile-table
      :data-type="dataType"
      :table-meta="tableMeta"
      :data="projects"
      :rowMeta="rowMeta"
      :filter-meta="filterMeta"
      :column-meta="columnMeta"
      :showContextMenu="true"
      @fieldAction="fieldAction" />
      <new-button @clicked="openProjectModal()" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import ProjectModal from '@/components/modals/ProjectModal'
import AddressModal from '@/components/modals/AddressModal'
import CustomerModal from '@/components/modals/CustomerModal'
import ContactModal from '@/components/modals/ContactModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-sitemap'
      },

      filterMeta:
      [
        {
          fieldId: 'projectCode',
          type: 'string',
          label: 'Projektnummer'
        },
        {
          fieldId: 'showAll',
          type: 'bool',
          label: 'Alla'
        },
        {
          fieldId: 'customerName',
          type: 'string',
          label: 'Kund'
        },
        {
          fieldId: 'mainContactName',
          type: 'string',
          label: 'Beställare'
        },
        {
          fieldId: 'objectName',
          type: 'string',
          label: 'Objekt'
        },
        {
          fieldId: 'address',
          type: 'string',
          label: 'Adress'
        },
        {
          fieldId: 'projectOwnerUserInitials',
          type: 'string',
          label: 'Projektansvarig'
        },
        {
          fieldId: 'projectReviewerUserInitials',
          type: 'string',
          label: 'Granskare'
        },
        {
          fieldId: 'tags',
          type: 'multi-select',
          placeholder: 'Välj taggar',
          options: [],
          label: 'Taggar'
        }
      ],

      columnMeta: {
        hasActions: false,
        items: [
          {
            fieldId: 'projectCode',
            label: 'Projektnummer',
            actionType: 'fieldAction',
            action: 'displayProject'
          },
          {
            fieldId: 'block',
            label: 'Objekt'
            // actionType: 'fieldAction',
            // action: 'displayAddress'
          },
          {
            fieldId: 'customerName',
            label: 'Kund'
            // actionType: 'fieldAction',
            // action: 'displayCustomer'
          },
          {
            fieldId: 'mainContactFullName',
            label: 'Beställare'
            // actionType: 'fieldAction',
            // action: 'displayContact'
          },
          /* {
            fieldId: 'projectOwnerUserInitials',
            label: 'Ansvarig'
          },
          {
            fieldId: 'projectReviewerUserInitials',
            label: 'Granskare'
          }, */
          {
            fieldId: 'objectAddressFormatted',
            label: 'Adress'
            // actionType: 'fieldAction',
            // action: 'displayAddress'
          },
          {
            fieldId: 'numberOfTags',
            label: 'Taggar',
            actionType: 'fieldAction',
            action: 'displayProject',
            iconClass: 'fal fa-tag'
          },
          {
            fieldId: 'planned',
            label: 'Planerade'
            // actionType: 'fieldAction',
            // action: 'displayWorkOrders'
          },
          {
            fieldId: 'registered',
            label: 'Registrerade'
            // actionType: 'fieldAction',
            // action: 'displayWorkOrders'
          },
          {
            fieldId: 'invoiced',
            label: 'Fakturerade'
            // actionType: 'fieldAction',
            // action: 'displayWorkOrders'
          },
          {
            fieldId: 'budget',
            label: 'Budget',
            dataType: 'currency'
            // actionType: 'fieldAction',
            // action: 'displayProject'
          }
        ]
      },

      rowMeta: {
        rowClass: (row) => {
          if (row.paymentRemark) {
            return 'agile-table-red-row'
          }
        }
      }
    }
  },

  watch: {
    'projects.filter': {
      handler () {
        if (this.$route.name === 'Home_ProjectOwner') {
          // this.projects.filter.projectOwnerUserInitials = this.$store.state.auth.user.initials
          if (this.projects.filter.projectOwnerUserInitials && (this.projects.filter.projectOwnerUserInitials.toLowerCase() === this.projects.defaultFilter.projectOwnerUserInitials.toLowerCase())) {
            this.$route.meta.title = 'Hem » Ansvarig'
          } else {
            this.$route.meta.title = 'Hem » Projekt (filtrerad)'
          }
        } else if (this.$route.name === 'Home_ProjectReviewer') {
          // this.projects.filter.projectReviewerUserInitials = this.$store.state.auth.user.initials
          if (this.projects.filter.projectReviewerUserInitials && (this.projects.filter.projectReviewerUserInitials.toLowerCase() === this.projects.defaultFilter.projectReviewerUserInitials.toLowerCase())) {
            this.$route.meta.title = 'Hem » Granskare'
          } else {
            this.$route.meta.title = 'Hem » Projekt (filtrerad)'
          }
        }

        this.getListDataByContext()
      },
      deep: true
    }
    // ,
    // '$route': 'projectRouteUpdate'
  },

  // beforeMount () {
  //   this.projectRouteUpdate()
  // },

  computed: {
    dataType () {
      if (this.$route.name === 'Home_ProjectOwner') {
        return 'projectsOwner'
      } else if (this.$route.name === 'Home_ProjectReviewer') {
        return 'projectsReviewer'
      } else {
        return 'projects'
      }
    },

    ...mapState({
      projects (state) {
        if (this.$route.name === 'Home_ProjectOwner') {
          return state.projectsOwner.all
        } else if (this.$route.name === 'Home_ProjectReviewer') {
          return state.projectsReviewer.all
        } else {
          return state.projects.all
        }
      }
    })
  },

  methods: {
    ...mapActions({
      getAllTags: 'projects/getAllTags',
      getListData: 'projects/getListData',
      getListDataReviewer: 'projectsReviewer/getListData',
      getListDataOwner: 'projectsOwner/getListData',
      initializeProject: 'projects/initialize',
      initializeReviewer: 'projectsReviewer/initialize',
      initializeOwner: 'projectsOwner/initialize'
    }),

    initializeByContext () {
      if (this.$route.name === 'Home_ProjectOwner') {
        this.initializeOwner()
        this.$route.meta.title = 'Hem » Ansvarig'
      } else if (this.$route.name === 'Home_ProjectReviewer') {
        this.initializeReviewer()
        this.$route.meta.title = 'Hem » Granskare'
      } else {
        this.initializeProject()
      }
    },

    // projectRouteUpdate () {
    //   if (this.$route.name === 'Home_ProjectOwner') {
    //     this.defaultFilter = Object.assign({}, this.ownerFilter)
    //     this.$route.meta.title = 'Hem » Ansvarig'
    //   } else if (this.$route.name === 'Home_ProjectReviewer') {
    //     this.defaultFilter = Object.assign({}, this.reviewerFilter)
    //     this.$route.meta.title = 'Hem » Granskare'
    //   } else {
    //     this.defaultFilter = Object.assign({}, this.projectFilter)
    //   }
    // },

    rowAction (action, project) {
      switch (action) {
      }
    },

    getListDataByContext () {
      this.projects.currentPage = 1
      if (this.$route.name === 'Home_ProjectOwner') {
        this.getListDataOwner()
      } else if (this.$route.name === 'Home_ProjectReviewer') {
        this.getListDataReviewer()
      } else {
        this.getListData()
      }
    },

    fieldAction (action, project) {
      switch (action) {
        case 'displayAddress':
          this.$panel(AddressModal, { id: project.addressId, displayCustomer: false }).then(() => {
            this.getListDataByContext()
          })
          break
        case 'displayCustomer':
          this.$panel(CustomerModal, { id: project.customerId }).then(() => {
            this.getListDataByContext()
          })
          break
        case 'displayProject':
          this.$panel(ProjectModal, { id: project.projectId })
          break
        case 'displayContact':
          this.$panel(ContactModal, { id: project.mainContactId }).then(() => {
            this.getListDataByContext()
          })
          break
        case 'displayWorkOrders':
          this.$router.push({ name: 'Project_WorkOrders', params: { projectCode: project.projectCode } })
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openProjectModal () {
      this.$panel(ProjectModal, { callingRoute: this.$route.name })
    }
  },

  mounted () {
    this.getAllTags().then(data => {
      var tagFilter = this.filterMeta.find(x => x.fieldId === 'tags')
      tagFilter.options = data.map(x => {
        return { value: x.tagId, text: x.name }
      })
    })
  },

  created () {
    this.initializeByContext()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Projects/ProjectsPage.vue